import '../../App.css'
import { useState } from 'react';
import { TfiPencilAlt } from "react-icons/tfi"; 
import RollingCommission from '../../components/rollingCommission';
import { Modal, Input } from 'antd';
import Appconfig from '../../config/config'
import { useNavigate } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { useSelector, useDispatch } from 'react-redux';
import { emptyUserInfo } from '../../redux/slice/userInfo/userInfoSlice';
import { emptyBalance } from '../../redux/slice/user/userSlice';
import { emptyOpenBets } from '../../redux/slice/openBet/openBetSlice';
import { emptyLoingUserData } from '../../redux/slice/userData/userDataSlice';
import axios from 'axios';
import AccountSidebar from 'components/AccountSidebar';

const MyProfile = () => {
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state?.userInfo?.userdata);
    const dispatch = useDispatch();

    const [openEdit, setOpenEdit] = useState(false)
    const [openRollingCommission, setOpenRollingCommission] = useState(false)
    const [user_nameValidationError, setUser_NameValidationError] = useState("Please enter old password");
    const [passwordValidationError, setPasswordValidationError] = useState("Please enter new password");
    const [conpasswordValidationError, setConPasswordValidationError] = useState("Please check your confirm password");

    const [button, setButton] = useState(false)

    const [formData, setformData] = useState({
        user_id: userInfo?._id,
        name: userInfo?.name,
        user_name: userInfo?.user_name,
        user_type: userInfo?.user_type,
        old_password: '',
        new_password: '',
        con_password: '',
    });

    function checkValidation() {
        let isValid = true;
        if (formData.old_password.trim() === "") {
            setUser_NameValidationError('Please enter old password')
            document.querySelector('.oldpassword-error').classList.remove('hidden');
            isValid = false;
        }
        if (formData.new_password.trim() === "") {
            setPasswordValidationError('Please enter new password')
            document.querySelector('.newpassword-error').classList.remove('hidden');
            isValid = false;
        }
        if (formData.con_password.trim() !== formData.new_password.trim()) {
            document.querySelector('.conpassword-error').classList.remove('hidden');
            setConPasswordValidationError('Please check your confirm password')
            isValid = false;
        }
        return isValid;
    }

    function setOldPassword(value) { setformData({ ...formData, old_password: value }) }
    function setNewPassword(value) { setformData({ ...formData, new_password: value }) }
    function setConPassword(value) { setformData({ ...formData, con_password: value }) }

    const changePassword = async () => {
        if (checkValidation()) {
            formData.master_id = userInfo?.master_id;
            formData.masters = userInfo?.masters;
            setButton(true);
            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/auraChangePassword`,
                headers: { 'Content-Type': 'application/json' },
                data: JSON.stringify(formData)
            };
            axios(config)
                .then(function (response) {
                    if (response.data.result) {
                        NotificationManager.success(response.data.message, '', 3000);
                        setOpenEdit(false);
                        setButton(false);
                        setTimeout(() => {
                            localStorage.clear();
                            dispatch(emptyUserInfo());
                            dispatch(emptyBalance());
                            dispatch(emptyOpenBets());
                            dispatch(emptyLoingUserData());
                            navigate("/login");
                        }, 3000)
                    } else {
                        NotificationManager.error(response.data.message, '', 3000);
                        setButton(false);
                    }
                })
                .catch(err => { console.log(err); setButton(false); });
        }
    }

    const SectionHeader = ({ title }) => (
        <div className='px-3 py-2 bg-[#7e97a7] text-white font-bold text-sm rounded-t-sm'>
            {title}
        </div>
    );

    const InfoRow = ({ label, value, action }) => (
        <div className='flex items-center border-b border-gray-200 py-2 px-3 text-[12px]'>
            <div className='w-1/3 font-semibold text-gray-600'>{label}</div>
            <div className='w-2/3 text-gray-800 flex justify-between items-center'>
                <span className="truncate mr-2">{value}</span>
                {action && <span>{action}</span>}
            </div>
        </div>
    );

    return (
        /* Added pt and pb to prevent hiding behind fixed header/footer on mobile */
        <div className="bg-[#eeeeee] min-h-screen font-sans pt-[60px] pb-[80px] lg:pt-0 lg:pb-4 px-2 md:px-4">
            <div className="max-w-[1300px] mx-auto flex flex-col lg:flex-row gap-0 items-start">
                
                {/* Sidebar Container */}
                <div className="w-full lg:w-[240px] sticky top-[70px]">
                    <AccountSidebar />
                </div>

                {/* Main Content Area */}
                <div className="flex-1 w-full bg-transparent">
                    <h2 className="text-sm font-bold mb-3 mt-3 text-gray-800 uppercase tracking-tight">Account Details</h2>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        
                        {/* Section 1: About You */}
                        <div className="bg-white border border-gray-300 rounded shadow-sm overflow-hidden">
                            <SectionHeader title="About You" />
                            <InfoRow label="First Name" value={userInfo?.user_name || '--'} />
                            <InfoRow label="Last Name" value={userInfo?.name || '--'} />
                            <InfoRow label="Birthday" value="--" />
                            <InfoRow 
                                label="Password" 
                                value="****************" 
                                action={
                                    <button className='text-blue-600 hover:underline font-bold' onClick={() => setOpenEdit(true)}>
                                        Edit
                                    </button>
                                }
                            />
                        </div>

                        {/* Section 2: Setting */}
                        <div className="bg-white border border-gray-300 rounded shadow-sm overflow-hidden">
                            <SectionHeader title="Setting" />
                            <InfoRow label="Currency" value="PIN" />
                            <InfoRow label="Odds Format" value="--" />
                        </div>

                        {/* Section 3: Address */}
                        <div className="bg-white border border-gray-300 rounded shadow-sm overflow-hidden">
                            <SectionHeader title="Address" />
                            <InfoRow label="Address" value="--" />
                            <InfoRow label="Town/City" value="--" />
                            <InfoRow label="Country" value="--" />
                            <InfoRow label="Country/State" value="--" />
                            <InfoRow label="Postcode" value="--" />
                            <InfoRow label="Timezone" value="IST" />
                        </div>

                        {/* Section 4: Commission */}
                        <div className="bg-white border border-gray-300 rounded shadow-sm overflow-hidden md:mt-0">
                            <SectionHeader title="Commission" />
                            <InfoRow label="Comm charged" value={`${userInfo?.commission || '0.00'} %`} />
                            <InfoRow 
                                label="Rolling Comm" 
                                value="View Details"
                                action={
                                    <button onClick={() => setOpenRollingCommission(true)} className="text-blue-600 hover:underline font-bold">
                                        Open
                                    </button>
                                } 
                            />
                            <InfoRow label="Exposure Limit" value={userInfo?.exposer_limit || '--'} />
                        </div>

                    </div>
                </div>
            </div>

            {/* Modals - Optimized for Mobile Widths */}
            <Modal 
                title={'Rolling Commission'} 
                className='top-5 w-[95vw] lg:w-[34vw]' 
                maskClosable={true}
                onCancel={() => setOpenRollingCommission(false)} 
                footer={null} 
                open={openRollingCommission} 
            >
                <RollingCommission />
            </Modal>

            <Modal 
                className='password-model top-5 w-[95vw] lg:w-[34vw]'
                footer={null}
                mask={true} 
                open={openEdit} 
                closable={false}
                onCancel={() => setOpenEdit(false)}
            >
                <div className='overflow-hidden rounded-lg'>
                    <div className='px-4 py-3 font-bold bg-[linear-gradient(-180deg,#474747_0%,#070707_100%)] text-white flex items-center justify-between'>
                        <h5 className='text-base font-bold m-0'>Change Password</h5>
                        <button type="button" onClick={() => setOpenEdit(false)} className="text-2xl leading-none">×</button>
                    </div>
                    
                    <div className='bg-white p-4 lg:p-6'>
                        <div className='space-y-6'>
                            <div className='relative'>
                                <label className='block text-xs font-bold mb-1 text-gray-700'>Old Password</label>
                                <Input.Password 
                                    onChange={(e) => setOldPassword(e.target.value)}
                                    className='h-10' placeholder="Old Password.." 
                                />
                                <span className="absolute -bottom-5 oldpassword-error hidden text-[11px] text-red-500 font-medium">
                                    {user_nameValidationError}
                                </span>
                            </div>

                            <div className='relative'>
                                <label className='block text-xs font-bold mb-1 text-gray-700'>New Password</label>
                                <Input.Password 
                                    onChange={(e) => setNewPassword(e.target.value)} 
                                    className='h-10' placeholder="New Password.." 
                                />
                                <span className="absolute -bottom-5 newpassword-error hidden text-[11px] text-red-500 font-medium">
                                    {passwordValidationError}
                                </span>
                            </div>

                            <div className='relative'>
                                <label className='block text-xs font-bold mb-1 text-gray-700'>Confirm Password</label>
                                <Input.Password 
                                    onChange={(e) => setConPassword(e.target.value)} 
                                    className='h-10' placeholder="Confirm Password.." 
                                />
                                <span className="absolute -bottom-5 conpassword-error hidden text-[11px] text-red-500 font-medium">
                                    {conpasswordValidationError}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className='flex items-center justify-end gap-3 p-4 border-t bg-gray-50'>
                        <button 
                            disabled={button} 
                            className='bg-[#1c272d] text-white px-6 py-2 rounded font-bold text-sm hover:bg-black transition-colors'
                            onClick={changePassword}
                        >
                            {button ? 'Updating...' : 'Confirm'}
                        </button>
                        <button 
                            className='bg-gray-300 text-gray-800 px-6 py-2 rounded font-bold text-sm hover:bg-gray-400 transition-colors'
                            onClick={() => setOpenEdit(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
export default MyProfile